import React from 'react';
import auth, { Auth } from './modules/auth';
import paymentDetail, { PaymentDetail } from './modules/paymentDetail';
import tenants, { Tenants } from './modules/tenants';
export type RootStore = {
  auth: Auth;
  paymentDetail: PaymentDetail;
  tenants: Tenants;
};

export const store: RootStore = {
  auth,
  paymentDetail,
  tenants
};

const StoreContext = React.createContext<RootStore>(store);

export const StoreProvider = StoreContext.Provider;

export const useStore = () => React.useContext(StoreContext);

export { auth, paymentDetail, tenants };
